import { render, staticRenderFns } from "./Icon.global.vue?vue&type=template&id=4ea52f75&scoped=true&lang=pug&"
import script from "./Icon.global.vue?vue&type=script&lang=ts&"
export * from "./Icon.global.vue?vue&type=script&lang=ts&"
import style0 from "./Icon.global.vue?vue&type=style&index=0&id=4ea52f75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea52f75",
  null
  
)

export default component.exports